@if (selected) {
<div class="step-body">
  <ng-content [slot]="key"></ng-content>
</div>
}
